module.exports = __webpack_public_path__ + "static/img/icon-download-green.072ee1d1.svg";